import { Component, input } from '@angular/core';
import { NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { MatOptionModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { Ad6Option } from '@library/shared/option';

import { Ad6ControlValueAccessorComponent } from './control-value-accessor';

@Component({
  selector: 'ad6-select',
  templateUrl: './select.component.html',
  imports: [MatSelectModule, MatOptionModule, MatFormFieldModule, ReactiveFormsModule],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: Ad6SelectComponent,
      multi: true,
    },
  ],
})
export class Ad6SelectComponent extends Ad6ControlValueAccessorComponent<Ad6Option> {
  label = input.required<string>();
  options = input.required<Ad6Option[]>();
  multiple = input<boolean>(false);
}
